import React, { useEffect, useState } from "react";
import "./All_Products.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  setProductFilter,
} from "../../../features/products/productsSlice";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { variant_type } from "../../../utils/common";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import CustomPaginate from "../../common-components/CustomPaginate/CustomPaginate";
import Loader from "../../common-components/Loader/Loader";

const All_Products = () => {
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const filters = useSelector((state) => state.product.filters);

  const handleCityChange = (selectedOption) => {};

  const handleResetFilters = () => {
    // keep variant_max: it is the price slider's upper bound, loaded from the API
    dispatch(
      setProductFilter({
        category_id: "",
        subcategory_ids: [],
        min_price: 0,
        max_price: filters.variant_max || 1200,
        in_stock: false,
        out_of_stock: false,
        concerns: [],
        name: "",
        sortBy: null,
        page: 1,
      }),
    );
  };

  const options = [
    { value: "az", label: "Name: Ascending " },
    { value: "za", label: "Name: Descending  " },
    { value: "low_to_high", label: "Price: Low to High" },
    { value: "high_to_low", label: "Price: High to Low" },
    { value: "new_to_old", label: "Newest First" },
    { value: "old_to_new", label: "Old First" },
  ];

  const [shapeId, setShapeId] = useState();
  const allProducts = useSelector((state) => state.product.allProducts);

  // useEffect(() => {
  //   dispatch(
  //     getAllProducts({
  //       category_id: filters.category_id,
  //       subcategory_id: JSON.stringify(filters?.subcategory_ids),
  //       name: filters?.name || "",
  //       minprice: filters.min_price,
  //       maxprice: filters.max_price,
  //       in_stock: filters.in_stock,
  //       sortBy: filters.sortBy,
  //       out_of_stock: filters.out_of_stock,
  //       concern_id: JSON.stringify(filters.concerns),
  //     }),
  //   );
  // }, [filters, dispatch]);

  const [loading, setLoading] = useState(true);

  const fetch = async (page = 1) => {
    setLoading(true);
    try {
      await dispatch(
        getAllProducts({
          category_id: filters.category_id,
          subcategory_id: JSON.stringify(filters?.subcategory_ids),
          name: filters?.name || "",
          minprice: filters.min_price,
          maxprice: filters.max_price,
          in_stock: filters.in_stock,
          sortBy: filters.sortBy,
          out_of_stock: filters.out_of_stock,
          concern_id: JSON.stringify(filters.concerns),
          page: filters?.page || page,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch(1);
  }, [filters, dispatch]);

  const handlePageChange = (page) => {
    fetch(page);
    dispatch(
      setProductFilter({
        page: Number(page),
      }),
    );
  };

  return (
    <section className="All_Products">
      {/* common component */}
      <div className="common_title_sort_holder">
        <p className="title_text">All Products</p>

        <div className="sort_reset_group">
          <div className="sort_reset_select">
            <Controller
              name="sort_by"
              control={control}
              defaultValue="relevance"
              render={({ field }) => (
                <Select
                  {...field}
                  options={options}
                  placeholder="Sort By"
                  value={
                    options.find(
                      (option) => option.value === filters?.sortBy,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption.value);

                    dispatch(
                      setProductFilter({
                        page: 1,
                        sortBy: selectedOption.value,
                      }),
                    );
                  }}
                />
              )}
            />
          </div>
          <button
            type="button"
            className="reset_filter_btn"
            onClick={handleResetFilters}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="all_prods_holder ">
        {loading ? (
          <Loader color={"#b1063b"} />
        ) : allProducts && allProducts?.data?.length > 0 ? (
          <div className="row inner-padding ">
            {allProducts?.data?.map((product, index) => {
              let metal;
              let size;
              let triple;
              if (
                Number(product?.variant_type_id) === Number(variant_type.Single)
              ) {
                metal = product?.Product_Variants?.[0];
              } else if (
                Number(product?.variant_type_id) === Number(variant_type.Double)
              ) {
                metal = product?.Product_Variants?.[0];
                size = metal?.Double_Variants?.[0];
              } else if (
                Number(product?.variant_type_id) === Number(variant_type.Triple)
              ) {
                metal = product?.Product_Variants?.[0];
                size = metal?.Double_Variants?.[0];
                triple = size?.Triple_Variants?.[0];
              }

              const activeVariant = triple || size || metal;

              return (
                <div
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 p-0 custom_col"
                  key={product?.id || index}
                >
                  <Product_Info_Card
                    product={product}
                    id={product?.id}
                    rating={product?.average_rating || 0}
                    imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                    vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                    productName={product?.name}
                    activeVariant={activeVariant}
                    priceText={activeVariant?.price || 0}
                    mrp={activeVariant?.mrp || 0}
                    kgText={metal?.Metal?.name}
                    savingPrice={
                      parseFloat(activeVariant?.mrp || 0) -
                      parseFloat(activeVariant?.price || 0)
                    }
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no_product_available_holder text-center w-100">
            <h3>No Product Available</h3>
          </div>
        )}
      </div>
      {allProducts?.total_pages > 1 && (
        <CustomPaginate
          handlePageChange={handlePageChange}
          currentPage={allProducts?.current_page}
          totalPages={allProducts?.total_pages}
        />
      )}
    </section>
  );
};

export default All_Products;
